import React from "react";
import { Col, Container, Row } from "react-bootstrap";

function Ressult() {
  return (
    <section className="intro_section p-100">
      <Container>
        <Row>
          <Col xs={12} md={12} lg={5} xl={5} xxl={5} className="my-auto">
            <h2 style={{ color: "#000" }}>
              The <span style={{ color: "#C9318E" }}>Results</span>
            </h2>
          </Col>
          <Col
            xs={12}
            md={12}
            lg={6}
            xl={6}
            xxl={6}
            className="my-auto offset-lg-1"
          >
            <p>
              The end product, team Tekrevol created is a reliable,
              comprehensive, intuitive, and user-friendly portal tailor-made for
              real estate professionals. Re-Installer is everything realtors and
              sign installers hoped for, it provides all necessary details and
              ensures no more messed up orders and no more billing disputes.
            </p>
          </Col>
        </Row>
      </Container>
    </section>
  );
}

export default Ressult;
